import { MaterialThemeProvider } from 'dg-web-shared/common/hooks/MaterialThemeProvider';
import { parkingaboDefaultMuiTheme } from 'parkingabo-shared/theme/ParkingaboDefaultMuiTheme.tsx';
import { Language } from 'dg-web-shared/lib/Text.ts';
import { ReactNode } from 'react';

export function ParkingaboThemeProvider({
    language,
    children,
}: {
    language: Language;
    children: ReactNode;
}) {
    return (
        <MaterialThemeProvider
            theme={parkingaboDefaultMuiTheme}
            language={language}
        >
            {children}
        </MaterialThemeProvider>
    );
}
